import {AbstractDelete} from "../../../../clone/dialog/delete";
import PromiseRequest from "../../../../req/PromiseRequest";
import {global} from "../../../../appContext";

export {template} from "../../../../clone/dialog/delete";

interface IDeleteItem {
    id: number
    name: string
}

export class viewModel extends AbstractDelete {
    protected readonly EVENT_SUCCESS = "clientcredential.delete.success";

    protected override process(): Promise<unknown> {
        const req = new PromiseRequest("deleteobject");
        return req.request({id: (this.params.item as IDeleteItem).id})
            .then(() => {
                global.cacheManager.removeCache("searchobject");
                global.cacheManager.removeCache("getobject");
            });
    }
}
